<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$createDialog({
      type: "confirm",
      icon: "cubeic-alert",
      title: "提示",
      content: "是否完成支付",
      confirmBtn: {
        text: "完成支付",
        active: true,
        disabled: false,
        href: "javascript:;"
      },
      cancelBtn: {
        text: "重新支付",
        active: false,
        disabled: false,
        href: "javascript:;"
      },
      onConfirm: () => {
        this.$router.push(decodeURIComponent(this.doneRedirect));
      },
      onCancel: () => {
        this.$router.push(decodeURIComponent(this.redirect));
      }
    }).show();
  },
  computed: {
    doneRedirect() {
      return this.$route.query.doneRedirect;
    },
    redirect() {
      return this.$route.query.redirect;
    }
  }
};
</script>

<style>
</style>